module.exports = __webpack_public_path__ + "img/audio.8aabd1df.png";